<p-floatLabel>
  <p-select #placeSelector
        id="placeSelector"
        name="placeSelector"
        [options]="places"
        [(ngModel)]="selectedPlace"
        [showClear]="true"
        [checkmark]="true"
        [filter]="true"
        styleClass="w-100"
        [disabled]="isDisabled"
        (onChange)="onSelected()"
        optionLabel="name">
    <ng-template let-option pTemplate="item">
      {{ option?.name }}
    </ng-template>
  </p-select>
  <label for="placeSelector">
    <app-label-content [isRequired]="isRequired">
      {{ l('::Place') }}
    </app-label-content>
  </label>
</p-floatLabel>
